import { Link } from 'react-router-dom'
import { MenuLinks } from '@/constants/menu'
import BrandLogo from '@/components/BrandLogo/BrandLogo'

const MarketingNavbar = () => {
	return (
		<header className="sticky top-0 z-50 w-full border-b border-border/60 bg-background/70 backdrop-blur-xl">
			<div className="container flex h-16 items-center justify-between">
				<BrandLogo linkTo="/" size="sm" tone="default" />
				<div className="flex items-center gap-2">
					<Link to={MenuLinks.Login} className="btn btn-sm rounded-app px-3 py-1.5 text-sm font-medium text-muted-foreground hover:bg-muted hover:text-foreground">
						Sign in
					</Link>
					<Link to={`${MenuLinks.Register}?plan=trial`} className="btn-ember-outline btn-sm rounded-app px-3 py-1.5 text-sm">
						Start Trial
					</Link>
					{/* <Link to={MenuLinks.PublicPricing} className="btn-ember btn-sm rounded-app px-3 py-1.5 text-sm shadow-ember">
						Buy
					</Link> */}
				</div>
			</div>
		</header>
	)
}

export default MarketingNavbar
